import reducer from "./reducer";
export { default as AudioPlayer } from "./components/index";
export { default as audioPlayerReducerName } from "./constants";
export default reducer;
